/**
 * Format: Price
 * -----------------------------------------------------------------------------
 * Formats Shopify storefront API money and price responses.
 *
 */

/**
 * Format money v2.
 * - https://shopify.dev/docs/api/storefront/2023-07/objects/MoneyV2
 * @param {Object} price - MoneyV2 response.
 * @returns {Object}
 */
export function formatMoneyV2(price) {
  if (!price) {
    return {
      amount: false,
      currencyCode: false,
    }
  }

  return {
    amount: formatPriceAmount(price.amount),
    currencyCode: price.currencyCode,
  }
}

/**
 * Format a price amount.
 * - If the amount can be converted to a number, it is converted and multiplied
 *   by 100 to get the cents amount.
 * - Otherwise returns `false`.
 * @param {*} amount - Amount value to process.
 * @returns {Number|Boolean}
 */
export function formatPriceAmount(amount) {
  // eslint-disable-next-line no-undefined
  if (amount === null || amount === undefined) {
    return false
  }

  const numericAmount = Number(amount)

  if (isNaN(numericAmount)) {
    return false
  }

  return numericAmount * 100
}

/**
 * Format product price range.
 * - https://shopify.dev/docs/api/storefront/2023-07/objects/ProductPriceRange
 * @param {Object} price - ProductPriceRange response.
 * @returns {Object}
 */
export function formatProductPriceRange(price) {
  return {
    amount: formatPriceAmount(price?.minVariantPrice.amount),
    currencyCode: price?.minVariantPrice.currencyCode,
    max: formatPriceAmount(price?.maxVariantPrice.amount),
    min: formatPriceAmount(price?.minVariantPrice.amount),
    varies: price?.maxVariantPrice.amount !== price?.minVariantPrice.amount,
  }
}
